import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import translate from '../../languages/translate';
import AuthService from '../../services/AuthService';
import {
    Nav,
    NavbarContainer,
    Logo,
    Burger,
    Menu,
    Item,
    NavLinks,
    ItemBtn,
    BtnLink,
    NavButton,
    BtnLogout
} from './NavbarElements';




const Navbar = () => {
    
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const handleLogout = () => {
        AuthService.logout();
        window.location = '/';
    }



    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();

    return (
        <>
     
            <IconContext.Provider value={{ color: 'white' }}>
                <Nav>
                    <NavbarContainer>
                        <Logo to="/">
                        {translate("bisharatfamily")}  
                        </Logo>



                        <Burger onClick={handleClick}>
                            {click ? <FaTimes size={40} color="#1A4301" /> : <FaBars size={40} color="#1A4301" />}
                        </Burger>
                        <Menu onClick={handleClick} click={click}>
                          
                        {/* <Item>
                                <NavLinks to='/family-activities'>فعاليّات </NavLinks>
                            </Item>

                            <Item>
                                <NavLinks to='/family-notification'>اشعارات </NavLinks>
                            </Item>
 */}

                            <Item>
                                <NavLinks to='/family-tree-instruction'>{translate("familytree")}</NavLinks>
                            </Item>

                            <Item>
                                <NavLinks to='/family-gallery'>{translate("gallery")}</NavLinks>
                            </Item>

                            <Item>
                                <NavLinks to='/family-history'>{translate("historical-info")} </NavLinks>
                            </Item>

                            <Item>
                                <NavLinks to='/family-aboutus'>{translate("about-us")}</NavLinks>
                            </Item>

                            <Item>
                                <NavLinks to='/'>{translate("homepage")}</NavLinks>
                            </Item>


                            {(whatRole === ('MODERATOR')) || (whatRole === ('ADMIN')) ?
                                <Item>
                                    <NavLinks to='/adminboard'> {translate("adminboard")} </NavLinks>
                                </Item> : <></>
                            }
                            <ItemBtn>
                                {loggedInUser ?
                                    <BtnLogout onClick={handleLogout}>{translate("logout")}</BtnLogout>
                                    :
                                    <BtnLink to='/login'> <NavButton>{translate("login")}</NavButton> </BtnLink>
                                }
                            </ItemBtn>
                        </Menu>
                    </NavbarContainer>
                </Nav>
            
            </IconContext.Provider>
          
        </>
    )
}

export default Navbar
